import { GroupedPaymentPlan } from '../types/groupedPaymentPlans';

/**
 * Whether a Stripe grouped plan is a family (self-service) plan.
 * Prefers product metadata.tier=family; falls back to product name/description keywords.
 */
export function isFamilyPlan(plan: GroupedPaymentPlan): boolean {
  const tier = plan.metadata?.tier?.toLowerCase();
  if (tier === 'family') {
    return true;
  }
  if (tier) {
    return false;
  }

  const planName = plan.productName.toLowerCase();
  const planDesc = plan.productDescription?.toLowerCase() || '';

  return planName.includes('family') || planDesc.includes('family');
}

export function findFamilyPlan(plans: GroupedPaymentPlan[]): GroupedPaymentPlan | undefined {
  return plans.find(isFamilyPlan);
}

export function getYearlyPriceId(plan: GroupedPaymentPlan): string | undefined {
  const yearly = plan.priceOptions.find((p) => p.interval === 'year');
  return yearly?.priceId ?? plan.priceOptions[0]?.priceId;
}

export function getYearlyDisplayAmount(plan: GroupedPaymentPlan): string | undefined {
  const yearly = plan.priceOptions.find((p) => p.interval === 'year');
  return yearly?.displayAmount ?? plan.priceOptions[0]?.displayAmount;
}
